
import { mapActions, mapState, mapGetters } from "vuex";
import dialogCloseBtn from "../common/dialog-close-btn.vue";

export default {
  components: { dialogCloseBtn },
  data() {
    return {
      selectedPrinter: "",
      menuLoading: false,
      loading: false,
      selectedItems: [],
      tab: 0,
      selectAll: false
    };
  },
  props: {
    dialog: false,
    assignPrinters: {
      default: []
    }
  },
  async mounted() {
    await this.getMenuList(false);
    this.selectedPrinter = this.assignPrinters[0];
    this.selectedItems = this.getPrinterAssignedItems(this.selectedPrinter).map(
      (el) => el.id
    );
  },
  computed: {
    ...mapState("restaurant", ["printers"]),
    ...mapState("menu", ["menuItems"]),
    ...mapGetters("menu", ["getPrinterAssignedItems"]),
    validItems() {
      return (
        this.menuItems?.filter(
          (item) => !item.printer_id || item.printer_id == this.selectedPrinter
        ) || []
      );
    },
    allItemsSelected() {
      return (
        this.validItems.length > 0 &&
        this.selectedItems.length === this.validItems.length
      );
    }
  },
  watch: {
    tab(val) {
      this.selectedPrinter = this.assignPrinters[val];
    },
    selectedItems: {
      handler() {
        this.selectAll = this.allItemsSelected;
      },
      deep: true
    }
  },
  methods: {
    ...mapActions("menu", ["getMenuList"]),
    ...mapActions("restaurant", ["assignItemsToPrinter"]),
    getPrinterDisplayName(p) {
      const printer = this.printers.find((el) => el.id == p);
      return printer?.nickname || printer?.name || "";
    },
    async handleAssignToPrinter() {
      this.loading = true;
      const $this = this;
      try {
        for (const printer of this.assignPrinters) {
          await $this.assignItemsToPrinter({
            printer,
            payload: { items: this.selectedItems }
          });
        }
        this.getMenuList(true);
        this.$nuxt.$emit("show-toast", {
          text: "Items assigned successfully",
          color: "success darken-2",
          icon: "done",
          flat: true
        });
        this.$emit("close-dialog");
      } catch (err) {
        this.$nuxt.$emit("show-error-toast", err);
      }
      this.loading = false;
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedItems = this.validItems.map((item) => item.id);
      } else {
        this.selectedItems = [];
      }
    }
  }
};
